import { useMemo } from "react";

export function useFilteredList<T>(
  items: T[],
  query: string,
  getSearchableStrings: (item: T) => (string | null | undefined)[],
): T[] {
  return useMemo(() => {
    const normalized = query.trim().toLowerCase();
    if (!normalized) return items;
    return items.filter((item) =>
      getSearchableStrings(item).some((s) =>
        s != null && s.toLowerCase().includes(normalized),
      ),
    );
  }, [items, query, getSearchableStrings]);
}
